import { Grid } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import { MxChangeLogArrow } from "./MxChangeLogArrow";

interface MxChangeLogDeepArrowProps {
  title: string;
  changes: {
    title: string;
    subChanges: {
      title: string;
      old: string;
      new: string;
    }[];
  }[];
}
const MxChangeLogDeepArrow = (props: MxChangeLogDeepArrowProps) => {
  return (
    <Grid container rowGap={1}>
      {props.title && (
        <Grid container item xs={12}>
          <MxTypography variant="caption" color="primary.main" fontWeight={600}>
            {props.title}
          </MxTypography>
        </Grid>
      )}

      <Grid container px={1} rowGap={1}>
        {props.changes.map((change, i) => (
          <Grid key={i} container item xs={12} rowGap={1}>
            <Grid container item xs={12}>
              <MxTypography variant="caption" color="primary.main" fontWeight={600}>
                {change.title}
              </MxTypography>
            </Grid>

            <Grid item xs={12}>
              {change.subChanges.map((subChange, z) => (
                <MxChangeLogArrow
                  title={subChange?.title}
                  fromText={subChange?.old}
                  toText={subChange?.new}
                />
              ))}
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default MxChangeLogDeepArrow;
